import { useEffect } from 'react'
import { trackPublicCtaViewed } from '~publish/helpers/publicTracking'
import type { JSX } from 'react'

import { Button, Dialog } from '@buffer-mono/popcorn'

import type { GuestDraftComposerHandoffAction } from '~publish/helpers/guestDraftHandoff'

const ACTION_COPY: Record<GuestDraftComposerHandoffAction, string> = {
  saveDraft: 'save this draft and keep your work',
  schedule: 'schedule this post and keep your work',
}

export function PublicAccountGateDialog({
  open,
  action,
  onOpenChange,
  onCreateAccount,
  onLogIn,
}: {
  open: boolean
  action: GuestDraftComposerHandoffAction
  onOpenChange: (open: boolean) => void
  onCreateAccount: () => void
  onLogIn: () => void
}): JSX.Element {
  useEffect(() => {
    if (open)
      trackPublicCtaViewed(`publish-composer-accountGate-${action}Signup-1`)
  }, [open, action])
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="medium">
        <Dialog.Header>
          <Dialog.Title>Create your Buffer account</Dialog.Title>
          <Dialog.Description>
            Create a free account to <strong>{ACTION_COPY[action]}</strong>.
            We’ll bring this draft and its images with you.
          </Dialog.Description>
        </Dialog.Header>
        <Dialog.Footer>
          <Button variant="secondary" onClick={onLogIn}>
            Log In
          </Button>
          <Button onClick={onCreateAccount}>Create account</Button>
        </Dialog.Footer>
        <Dialog.CloseButton />
      </Dialog.Content>
    </Dialog>
  )
}
